import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface EncounterDto {
	id: string;
	worldId: string;
	name: string;
	description?: string | null;
	gmNotes?: string | null;
	imageAssetId?: string | null;
	mapAssetId?: string | null;
	pdfAssetId?: string | null;
	environment?: string | null;
	escalation?: string | null;
	aftermath?: string | null;
	foundryId?: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface EncountersListResponse {
	encounters: EncounterDto[];
	total: number;
}

export interface EncounterGetResponse {
	encounter: EncounterDto;
}

export interface UpsertEncounterRequest {
	name: string;
	description?: string | null;
	gmNotes?: string | null;
	imageAssetId?: string | null;
	mapAssetId?: string | null;
	pdfAssetId?: string | null;
	environment?: string | null;
	escalation?: string | null;
	aftermath?: string | null;
	foundryId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class EncountersService {
	constructor(private readonly http: HttpClient) {}

	list(worldId: string, args?: { q?: string }): Observable<EncountersListResponse> {
		let params = new HttpParams().set('format', 'list');
		if (args?.q) params = params.set('q', args.q);
		return this.http.get<EncountersListResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/encounters`, { params });
	}

	get(worldId: string, encounterId: string): Observable<EncounterGetResponse> {
		return this.http.get<EncounterGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/encounters/${encounterId}`);
	}

	create(worldId: string, request: UpsertEncounterRequest): Observable<EncounterGetResponse> {
		return this.http.post<EncounterGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/encounters`, {
			Name: request.name,
			Description: request.description ?? null,
			GmNotes: request.gmNotes ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			MapAssetId: request.mapAssetId ?? null,
			PdfAssetId: request.pdfAssetId ?? null,
			Environment: request.environment ?? null,
			Escalation: request.escalation ?? null,
			Aftermath: request.aftermath ?? null,
			FoundryId: request.foundryId ?? null,
		});
	}

	update(worldId: string, encounterId: string, request: UpsertEncounterRequest): Observable<EncounterGetResponse> {
		return this.http.put<EncounterGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/encounters/${encounterId}`, {
			Name: request.name,
			Description: request.description ?? null,
			GmNotes: request.gmNotes ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			MapAssetId: request.mapAssetId ?? null,
			PdfAssetId: request.pdfAssetId ?? null,
			Environment: request.environment ?? null,
			Escalation: request.escalation ?? null,
			Aftermath: request.aftermath ?? null,
			FoundryId: request.foundryId ?? null,
		});
	}

	delete(worldId: string, encounterId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/worlds/${worldId}/encounters/${encounterId}`);
	}
}
